import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmailListComponent } from './EmailList.component';

@NgModule({
    imports: [CommonModule],
    declarations: [EmailListComponent],
    exports: [EmailListComponent],
    providers: []
})
export class EmailListModule {}
